export function humanizeEnumValue(value) {
  return String(value || '')
    .trim()
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

function toTranslationKeyPart(value) {
  const parts = String(value || '')
    .trim()
    .toLowerCase()
    .split(/[._-]+/)
    .filter(Boolean);

  return parts
    .map((part, index) => (
      index === 0
        ? part
        : part.charAt(0).toUpperCase() + part.slice(1)
    ))
    .join('');
}

export function getEnumOptionLabel(t, namespace, value, fallback = humanizeEnumValue(value)) {
  const normalizedNamespace = String(namespace || '').trim();
  const keyPart = toTranslationKeyPart(value);
  if (!normalizedNamespace || !keyPart || typeof t !== 'function') {
    return fallback;
  }

  const key = `enum.${normalizedNamespace}.${keyPart}`;
  const translated = t(key, { defaultValue: fallback });
  return translated === key ? fallback : translated;
}
